exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Users_panel__1vbnN {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding: 0 16px 16px 16px;\n  box-sizing: border-box;\n  background-color: #fff; }\n", ""]);

// exports
exports.locals = {
	"panel": "Users_panel__1vbnN"
};